// extracted by mini-css-extract-plugin
export default {"container":"style_container__X46mJ","workspace":"style_workspace__x4qMg"};